import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import ChevronLeftLightIcon from '../assets/li_chevron-left-light.svg';
import ChevronLeftIcon from '../assets/li_chevron-left.svg';
import { nonSpectreJourney } from '../utils/backgroundImage';

type IProps = {
  onClick?: () => void;
  onPointerDown?: () => void;
  onPointerUp?: () => void;
  onPointerCancel?: () => void;
  children?: React.ReactNode;
  className?: string;
  hide?: boolean;
  disabled?: boolean;
  journeyId?: string;
};

function BackButton(props: IProps) {
  const classNames = twMerge(
    clsx(
      'bg-surface-secondary flex items-center p-2 rounded-full cursor-pointer hover:opacity-[0.7]',
      props.className,
      { invisible: props.hide },
      {
        'opacity-40 cursor-default pointer-events-none`': props.disabled,
      }
    )
  );
  return (
    <button
      type="button"
      data-back-button="true"
      className={classNames}
      onClick={props.onClick}
      disabled={props.disabled}
      onPointerDown={() => {
        if (props.disabled || props.hide) return;
        props.onPointerDown?.();
      }}
      onPointerUp={() => {
        if (props.disabled || props.hide) return;
        props.onPointerUp?.();
      }}
      onPointerCancel={() => {
        if (props.disabled || props.hide) return;
        props.onPointerCancel?.();
      }}
      onMouseDown={(event) => {
        // Keep the focused field from blurring before click. Blur would
        // trigger Pega field validation (e.g. "Cannot be blank") first.
        event.preventDefault();
      }}
    >
      <img src={nonSpectreJourney(props.journeyId) ? ChevronLeftLightIcon : ChevronLeftIcon} alt="Back" />
      {props.children}
    </button>
  );
}

export default BackButton;
